import { createContext } from 'react'; 

const AuthContext = createContext(null);
//set initial value of user to null (pre-login)
export default AuthContext;